import React, {forwardRef} from 'react';

interface FormInputProps {
    formText: string;
    placeholder?: string;
    required?: boolean;
    [key: string]: any;
}

const  FormInput = forwardRef<HTMLInputElement, FormInputProps>(
    ({ formText, placeholder = '', required, ...props }, ref) => {
        return (
            <div className="form-container">
                <span className="form-text">
                    {formText}
                    {required && <span className="required-text"> *</span>}
                </span>
                <input
                    type="text"
                    className="form-input"
                    placeholder={placeholder}
                    ref={ref} // ref'i burada geçiriyoruz
                    {...props} // Diğer props'ları geçiriyoruz
                />
            </div>
        );
    }
);

FormInput.displayName = 'FormInput';

export default FormInput;
